import { APIService } from "../../../../network/api/APIService"

export const ProductsData = ({ app_id, pageFilters }) => {

    let baseEndpoint = `/shop/api/products/?app_id=${app_id}`;


    const filtersQuery = Object.entries(pageFilters)
        .filter(([_, value]) => value !== null && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const endpoint = `${baseEndpoint}${filtersQuery ? `&${filtersQuery}` : ""}`;

    const config = {
        endpoint: endpoint,
        method: "GET",
        credentials: "include",
    };

    return APIService(config);
}